export const RECIPIENTS_NONE = 0
export const RECIPIENTS_TEST_GROUP = 1
export const RECIPIENTS_GROUP_FILTER = 2
export const RECIPIENTS_ALL = 3

export const GROUP_TYPE_TEST = 'Test'
